module.exports = __webpack_public_path__ + "site/img/youtube.642bfb07.png";